<button [attr.id]="'btnDialogClose'" mat-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<h1 mat-dialog-title>{{ 'group-member.modal_title_check_invitations' | translate }}</h1>
<div class="content-height" mat-dialog-content>
  <app-pagination-list
    #paginator
    (emitPageChange)="updatePagedInvitations($event)"
    [_showEmpty]="false"
    [_isLoading]="(isLoading$ | async)"
    [_data]="(pendingInvitationsData$ | async)"
  ></app-pagination-list>

  <div *ngIf="(isLoading$ | async)" class="text-center">
    <app-loader></app-loader>
  </div>

  <div *ngIf="!(isLoading$ | async)">
    <div *ngIf="(pagedInvitations$ | async).length > 0; then thenShowInvitations else elseShowNoInvitations"></div>
    <ng-template #thenShowInvitations>
      <div *ngFor="let invitation of (pagedInvitations$ | async); trackBy: helper.trackById">
        <app-card-pending-invitation
          [_invitation]="invitation"
          [_studyCode]="invitation.attributes.code"
          [_isManager]="isManager"
          [_setStudies]="[study]"
          (emitDelete)="removeInvitation(invitation)"
          (emitUpdate)="updateInvitation(invitation)"
          (emitStudyCodeUpdate)="updateStudyCode(invitation, $event)"
        ></app-card-pending-invitation>
      </div>
    </ng-template>
    <ng-template #elseShowNoInvitations>
      <p>{{ 'patient.no_pending_invitations' | translate }}</p>
    </ng-template>
  </div>
</div>
